//# sourceMappingURL=update.mjs.map
/// <reference types="./update.d.mts" />
import * as $auth0 from "../../auth0_client/auth0/client.mjs";
import * as $remote from "../../data_types/data/remote.mjs";
import * as $bool from "../../gleam_stdlib/gleam/bool.mjs";
import * as $list from "../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../gleam_stdlib/gleam/option.mjs";
import * as $pair from "../../gleam_stdlib/gleam/pair.mjs";
import * as $effect from "../../redraw_lustre/redraw/lustre/effect.mjs";
import * as $toast from "../../redraw_toastify/toastify/toast.mjs";
import * as $analytics_effects from "../admin/effects/analytics.mjs";
import * as $content_library_effects from "../admin/effects/content_library.mjs";
import * as $maintenance_mode_effects from "../admin/effects/maintenance_mode.mjs";
import * as $organization_effects from "../admin/effects/organization.mjs";
import * as $project_effects from "../admin/effects/project.mjs";
import * as $proposal_effects from "../admin/effects/proposal.mjs";
import * as $user_effects from "../admin/effects/user.mjs";
import * as $window_effects from "../admin/effects/window.mjs";
import * as $jwt from "../admin/jwt.mjs";
import * as $ai_config from "../admin/update/ai_config.mjs";
import * as $content_library from "../admin/update/content_library.mjs";
import * as $dashboard from "../admin/update/dashboard.mjs";
import * as $data_sources from "../admin/update/data_sources.mjs";
import * as $label_translations from "../admin/update/label_translations.mjs";
import * as $llm_capacity from "../admin/update/llm_capacity.mjs";
import * as $maintenance_mode from "../admin/update/maintenance_mode.mjs";
import * as $organization_setup from "../admin/update/organization_setup.mjs";
import * as $organizations from "../admin/update/organizations.mjs";
import * as $project from "../admin/update/project.mjs";
import * as $proposal from "../admin/update/proposal.mjs";
import * as $sitemap from "../admin/update/sitemap.mjs";
import * as $weaviate from "../admin/update/weaviate.mjs";
import * as $msg from "../data/msg.mjs";
import * as $route from "../data/route.mjs";
import * as $store from "../data/store.mjs";
import { Store } from "../data/store.mjs";
import { toList, isEqual } from "../gleam.mjs";

function state_changed(user) {
  return $effect.from(
    (dispatch, _) => {
      let _pipe = user;
      let _pipe$1 = new $msg.AuthStateChanged(_pipe);
      return dispatch(_pipe$1);
    },
  );
}

export function update(store, msg) {
  if (msg instanceof $msg.ApplicationChangedRoute) {
    let uri = msg.route;
    let route = $route.from_uri(uri);
    let store$1 = $store.update_route(store, route);
    let title = $window_effects.update_page_title(route);
    let $ = $route.org_from_uri(uri);
    let $1 = store$1.organization;
    if ($ instanceof Some) {
      let selected = $1;
      let url_org = $[0];
      if (!isEqual(new Some(url_org), selected)) {
        let _pipe = $store.set_organization(store$1, new Some(url_org));
        return $pair.new$(
          _pipe,
          $effect.batch(
            toList([
              title,
              $content_library_effects.fetch_content_library(),
              $project_effects.fetch_projects(0),
              $proposal_effects.fetch_proposals(0),
            ]),
          ),
        );
      } else {
        return [store$1, title];
      }
    } else if ($1 instanceof Some) {
      return [
        store$1,
        $effect.batch(
          toList([title, $route.replace(route, store$1.organization)]),
        ),
      ];
    } else {
      return [store$1, title];
    }
  } else if (msg instanceof $msg.Auth0) {
    let auth0 = msg[0];
    if (auth0 instanceof $auth0.Login) {
      let _pipe = store.client;
      let _pipe$1 = $auth0.login_with_redirect(_pipe, state_changed);
      return ((_capture) => { return $pair.new$(store, _capture); })(_pipe$1);
    } else if (auth0 instanceof $auth0.Logout) {
      let _pipe = store.client;
      let _pipe$1 = $auth0.logout(_pipe, state_changed);
      return ((_capture) => { return $pair.new$(store, _capture); })(_pipe$1);
    } else if (auth0 instanceof $auth0.Authorize) {
      return [store, $effect.none()];
    } else {
      return [store, $effect.none()];
    }
  } else if (msg instanceof $msg.AuthStateChanged) {
    let user = msg[0];
    if (user instanceof Some) {
      let access_token = user[0][0];
      let user$1 = user[0][1];
      let permissions = $jwt.permissions(access_token);
      let is_admin = $list.contains(permissions, "super-admin");
      return $bool.guard(
        !is_admin,
        [store, $effect.none()],
        () => {
          let _pipe = store;
          let _pipe$1 = $store.update_connected_user(_pipe, user$1);
          return $pair.new$(
            _pipe$1,
            $effect.batch(
              toList([
                $user_effects.fetch_identity(access_token),
                $analytics_effects.fetch_analytics(),
                $analytics_effects.fetch_metrics(),
                $content_library_effects.fetch_content_library(),
                $maintenance_mode_effects.all(),
                $organization_effects.fetch_organizations(),
                $project_effects.fetch_projects(0),
                $proposal_effects.fetch_proposals(0),
              ]),
            ),
          );
        },
      );
    } else {
      return [$store.new$(store.client, store.route), $effect.none()];
    }
  } else if (msg instanceof $msg.ApiReturnedUserIdentity) {
    let user_id = msg.user_id;
    return [$store.set_user_id(store, user_id), $effect.none()];
  } else if (msg instanceof $msg.ContentLibrary) {
    let msg$1 = msg[0];
    return $content_library.update(store, msg$1);
  } else if (msg instanceof $msg.AiConfig) {
    let msg$1 = msg[0];
    return $ai_config.update(store, msg$1);
  } else if (msg instanceof $msg.UserSelectedOrganization) {
    let organization = msg.organization;
    return [
      $store.set_organization(store, new Some(organization)),
      $effect.batch(
        toList([
          $route.replace(store.route, new Some(organization)),
          $content_library_effects.fetch_content_library(),
          $project_effects.fetch_projects(0),
          $proposal_effects.fetch_proposals(0),
        ]),
      ),
    ];
  } else if (msg instanceof $msg.OrganizationSetup) {
    let msg$1 = msg[0];
    return $organization_setup.update(store, msg$1);
  } else if (msg instanceof $msg.MaintenanceMode) {
    let msg$1 = msg[0];
    return $maintenance_mode.update(store, msg$1);
  } else if (msg instanceof $msg.DataSources) {
    let msg$1 = msg[0];
    return $data_sources.update(store, msg$1);
  } else if (msg instanceof $msg.Organizations) {
    let msg$1 = msg[0];
    return $organizations.update(store, msg$1);
  } else if (msg instanceof $msg.Dashboard) {
    let msg$1 = msg[0];
    return $dashboard.update(store, msg$1);
  } else if (msg instanceof $msg.Project) {
    let msg$1 = msg[0];
    return $project.update(store, msg$1);
  } else if (msg instanceof $msg.Proposal) {
    let msg$1 = msg[0];
    return $proposal.update(store, msg$1);
  } else if (msg instanceof $msg.ApplicationRequestedToDisplayToast) {
    let level = msg.level;
    let message = msg.message;
    return [
      store,
      $effect.from(
        (_, _1) => {
          let _pipe = $toast.default_options();
          let _pipe$1 = $toast.type_(_pipe, level);
          return $toast.custom(_pipe$1, message);
        },
      ),
    ];
  } else if (msg instanceof $msg.ApiStartedLoadingRoles) {
    let _pipe = new Store(
      store.connections,
      store.organizations,
      store.organizations_tags,
      store.organizations_users,
      store.organizations_invitations,
      store.organizations_enabled_connections,
      store.organizations_ai_config,
      store.organizations_qm_rows,
      store.connected_sockets,
      store.projects,
      store.proposals,
      store.page_index,
      store.proposal_elements,
      store.answers,
      store.translations,
      store.label_translations,
      store.label_translations_search,
      store.label_translations_language_filter,
      store.label_translations_sort,
      store.llm_rate_limits,
      store.organizations_activity,
      store.llm_usage,
      store.llm_usage_by_org,
      store.client,
      store.organization,
      store.route,
      store.user,
      store.user_id,
      store.content_library,
      store.ingestion_control_sources,
      store.ingestion_control_sources_visibility,
      store.loading,
      store.users,
      new $remote.Loading(),
      store.maintenance_mode,
      store.data_sources,
      store.analytics,
      store.metrics_groups,
      store.dashboard_options,
      store.project_files,
      store.weaviate_migrations,
      store.weaviate_collections,
      store.sitemap_urls,
    );
    return $pair.new$(_pipe, $effect.none());
  } else if (msg instanceof $msg.ApiErroredRoles) {
    let content = msg.content;
    let _pipe = new Store(
      store.connections,
      store.organizations,
      store.organizations_tags,
      store.organizations_users,
      store.organizations_invitations,
      store.organizations_enabled_connections,
      store.organizations_ai_config,
      store.organizations_qm_rows,
      store.connected_sockets,
      store.projects,
      store.proposals,
      store.page_index,
      store.proposal_elements,
      store.answers,
      store.translations,
      store.label_translations,
      store.label_translations_search,
      store.label_translations_language_filter,
      store.label_translations_sort,
      store.llm_rate_limits,
      store.organizations_activity,
      store.llm_usage,
      store.llm_usage_by_org,
      store.client,
      store.organization,
      store.route,
      store.user,
      store.user_id,
      store.content_library,
      store.ingestion_control_sources,
      store.ingestion_control_sources_visibility,
      store.loading,
      store.users,
      new $remote.Errored(content),
      store.maintenance_mode,
      store.data_sources,
      store.analytics,
      store.metrics_groups,
      store.dashboard_options,
      store.project_files,
      store.weaviate_migrations,
      store.weaviate_collections,
      store.sitemap_urls,
    );
    return $pair.new$(_pipe, $effect.none());
  } else if (msg instanceof $msg.ApiReturnedRoles) {
    let roles = msg.roles;
    let _pipe = new Store(
      store.connections,
      store.organizations,
      store.organizations_tags,
      store.organizations_users,
      store.organizations_invitations,
      store.organizations_enabled_connections,
      store.organizations_ai_config,
      store.organizations_qm_rows,
      store.connected_sockets,
      store.projects,
      store.proposals,
      store.page_index,
      store.proposal_elements,
      store.answers,
      store.translations,
      store.label_translations,
      store.label_translations_search,
      store.label_translations_language_filter,
      store.label_translations_sort,
      store.llm_rate_limits,
      store.organizations_activity,
      store.llm_usage,
      store.llm_usage_by_org,
      store.client,
      store.organization,
      store.route,
      store.user,
      store.user_id,
      store.content_library,
      store.ingestion_control_sources,
      store.ingestion_control_sources_visibility,
      store.loading,
      store.users,
      new $remote.Loaded(roles),
      store.maintenance_mode,
      store.data_sources,
      store.analytics,
      store.metrics_groups,
      store.dashboard_options,
      store.project_files,
      store.weaviate_migrations,
      store.weaviate_collections,
      store.sitemap_urls,
    );
    return $pair.new$(_pipe, $effect.none());
  } else if (msg instanceof $msg.ApiStartedLoadingConnections) {
    let _pipe = new Store(
      new $remote.Loading(),
      store.organizations,
      store.organizations_tags,
      store.organizations_users,
      store.organizations_invitations,
      store.organizations_enabled_connections,
      store.organizations_ai_config,
      store.organizations_qm_rows,
      store.connected_sockets,
      store.projects,
      store.proposals,
      store.page_index,
      store.proposal_elements,
      store.answers,
      store.translations,
      store.label_translations,
      store.label_translations_search,
      store.label_translations_language_filter,
      store.label_translations_sort,
      store.llm_rate_limits,
      store.organizations_activity,
      store.llm_usage,
      store.llm_usage_by_org,
      store.client,
      store.organization,
      store.route,
      store.user,
      store.user_id,
      store.content_library,
      store.ingestion_control_sources,
      store.ingestion_control_sources_visibility,
      store.loading,
      store.users,
      store.roles,
      store.maintenance_mode,
      store.data_sources,
      store.analytics,
      store.metrics_groups,
      store.dashboard_options,
      store.project_files,
      store.weaviate_migrations,
      store.weaviate_collections,
      store.sitemap_urls,
    );
    return $pair.new$(_pipe, $effect.none());
  } else if (msg instanceof $msg.ApiErroredConnections) {
    let content = msg.content;
    let _pipe = new Store(
      new $remote.Errored(content),
      store.organizations,
      store.organizations_tags,
      store.organizations_users,
      store.organizations_invitations,
      store.organizations_enabled_connections,
      store.organizations_ai_config,
      store.organizations_qm_rows,
      store.connected_sockets,
      store.projects,
      store.proposals,
      store.page_index,
      store.proposal_elements,
      store.answers,
      store.translations,
      store.label_translations,
      store.label_translations_search,
      store.label_translations_language_filter,
      store.label_translations_sort,
      store.llm_rate_limits,
      store.organizations_activity,
      store.llm_usage,
      store.llm_usage_by_org,
      store.client,
      store.organization,
      store.route,
      store.user,
      store.user_id,
      store.content_library,
      store.ingestion_control_sources,
      store.ingestion_control_sources_visibility,
      store.loading,
      store.users,
      store.roles,
      store.maintenance_mode,
      store.data_sources,
      store.analytics,
      store.metrics_groups,
      store.dashboard_options,
      store.project_files,
      store.weaviate_migrations,
      store.weaviate_collections,
      store.sitemap_urls,
    );
    return $pair.new$(_pipe, $effect.none());
  } else if (msg instanceof $msg.ApiReturnedConnections) {
    let connections = msg.connections;
    let _pipe = new Store(
      new $remote.Loaded(connections),
      store.organizations,
      store.organizations_tags,
      store.organizations_users,
      store.organizations_invitations,
      store.organizations_enabled_connections,
      store.organizations_ai_config,
      store.organizations_qm_rows,
      store.connected_sockets,
      store.projects,
      store.proposals,
      store.page_index,
      store.proposal_elements,
      store.answers,
      store.translations,
      store.label_translations,
      store.label_translations_search,
      store.label_translations_language_filter,
      store.label_translations_sort,
      store.llm_rate_limits,
      store.organizations_activity,
      store.llm_usage,
      store.llm_usage_by_org,
      store.client,
      store.organization,
      store.route,
      store.user,
      store.user_id,
      store.content_library,
      store.ingestion_control_sources,
      store.ingestion_control_sources_visibility,
      store.loading,
      store.users,
      store.roles,
      store.maintenance_mode,
      store.data_sources,
      store.analytics,
      store.metrics_groups,
      store.dashboard_options,
      store.project_files,
      store.weaviate_migrations,
      store.weaviate_collections,
      store.sitemap_urls,
    );
    return $pair.new$(_pipe, $effect.none());
  } else if (msg instanceof $msg.Weaviate) {
    let msg$1 = msg[0];
    return $weaviate.update(store, msg$1);
  } else if (msg instanceof $msg.Sitemap) {
    let msg$1 = msg[0];
    return $sitemap.update(store, msg$1);
  } else if (msg instanceof $msg.LabelTranslations) {
    let msg$1 = msg[0];
    return $label_translations.update(store, msg$1);
  } else {
    let msg$1 = msg[0];
    return $llm_capacity.update(store, msg$1);
  }
}
